var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "150.625 231.25 173.125 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo_5_",
    transform: "matrix(1, 0, 0, 1, 537.149963, 86.425003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -385.625, 146.25)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.3,19.9h5.2l1-7.8l0,0l4.2,7.8h6l-4.5-7.4l0.5-0.2c2.3-0.8,3.8-3,3.9-6c0-3.6-2.1-5.7-6-5.8L8,0.6H2.9 L0.3,19.9L0.3,19.9z M6.9,9.2l0.7-4.7h1.5c1.4,0,2.2,0.8,2.3,2.1c0.1,1.6-0.9,2.5-2.6,2.6c-0.2,0-0.4,0-0.6,0H6.9L6.9,9.2z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,7L18,9.5c-0.2,1.2-0.3,2.4-0.3,3.6c-0.1,1.6,0.2,2.8,1,3.9c1.2,1.9,3.2,3,6.6,3.2 c4.8,0.3,8.1-1.9,8.9-4.9c0.2-0.8,0.4-1.6,0.5-2.4l1.5-12.4h-5.1l-1.3,10.3c-0.1,0.4-0.1,0.8-0.2,1.3c-0.4,2.4-1.4,3.4-3.5,3.4 c-0.2,0-0.4,0-0.6,0c-1.7-0.2-2.6-1.3-2.5-2.9c0.1-0.8,0.2-1.7,0.3-2.5l1.3-9.4h-5.2L18.3,7L18.3,7z",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52,1.3c-2.2-1-3.9-1.3-5.5-1.3c-1.2,0-2.5,0.3-3.6,0.7c-4.1,1.6-6.6,5.3-6.6,10c0,5.8,4.1,9.7,9.7,9.6 c0.7,0,1.5-0.1,2.2-0.2c0.8-0.2,1.4-0.3,1.8-0.5l0.7-0.3l0.7-5.3l-0.8,0.4c-1.3,0.7-2.7,1-4.3,1c-2.9-0.1-4.7-2.1-4.6-5 c0.1-3.2,2.4-5.5,5.5-5.5c1.4,0,2.6,0.3,4.3,1.3l0.8,0.5l0.7-5L52,1.3L52,1.3z",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.3,19.9 58.7,19.9 59.7,11.9 59.7,11.9 64.8,19.9 71.5,19.9 64.8,10.4 72.6,0.5 66.2,0.5 60.1,8.7  60.1,8.7 61.3,0.5 56,0.5 \t\t",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.1,18.2l0.5,0.3c2.2,1.4,4,1.9,6.3,1.8c4.4-0.1,7.4-3.1,7.4-6.9C85.2,11,84,9.2,81.4,8.1l-1.8-0.8 c-1-0.6-1.3-1-1.3-1.6c0-0.8,0.9-1.6,2.1-1.6c0.9,0,1.9,0.4,3.1,1.2l0.4,0.3l1.8-4l-0.5-0.3C83.8,0.5,81.7,0,79.6,0 c-4,0.1-6.5,2.4-6.8,5.6c-0.2,2.5,1,4.3,4.1,5.9c0.3,0.1,0.5,0.2,0.8,0.4c1.7,0.7,2.2,1.4,2.2,2.2c0,0.9-0.8,1.8-2.2,1.8 c-1.1,0-2.1-0.3-3.8-1.3l-0.7-0.4L71.1,18.2L71.1,18.2z",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "86.6,4.9 90.6,4.9 88.8,19.9 94,19.9 95.9,4.9 100,4.9 100.5,0.6 87.2,0.6 \t\t",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.8,7l-0.3,2.5c-0.2,1.2-0.3,2.4-0.3,3.6c-0.1,1.6,0.2,2.8,1,3.9c1.2,1.9,3.2,3,6.6,3.2 c4.8,0.3,8.1-1.9,8.9-4.9c0.2-0.8,0.4-1.6,0.5-2.4l1.5-12.4h-5.1l-1.3,10.3c-0.1,0.4-0.1,0.8-0.2,1.3c-0.4,2.4-1.4,3.4-3.5,3.4 c-0.2,0-0.4,0-0.6,0c-1.7-0.2-2.6-1.3-2.5-2.9c0.1-0.8,0.1-1.7,0.3-2.5l1.3-9.4h-5.2L101.8,7L101.8,7z",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "119.3,19.9 124.5,19.9 125.6,12.4 132.1,12.4 131.1,20 136.3,20 138.9,0.6 133.6,0.6 132.7,7.8  126.2,7.8 127.2,0.6 122,0.6 \t\t",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "138.9,19.9 150.1,19.9 150.8,15.3 144.8,15.3 146.8,0.6 141.5,0.6 \t\t",
    style: {
      fill: "rgb(201, 12, 15)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -385.625, 146.25)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "16.9,26.7 17,25.7 30.5,25.7 30.3,26.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.5,39.9 24.4,40.9 19.2,40.9 19.3,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.8,22.6l0.1-1H37h2.5c1.5,0,2.8,0.3,3.7,1H31.8L31.8,22.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.1,39.9 83,40.9 77.3,40.9 76.7,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.3,25.7l-0.4,1l-0.4-0.3c-0.4-0.3-0.8-0.5-1.1-0.7H98.3L98.3,25.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.1,22.6l0.1-1h7.2h0.8c1.6,0.1,2.9,0.4,3.8,1H102.1L102.1,22.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.2,29.7c0,0.3,0,0.7,0,1c0,0.4,0,0.7-0.1,1c0,0.3-0.1,0.7-0.1,1h-5.4c0.1-0.3,0.2-0.7,0.2-1h5.4 c0-0.3,0-0.6,0.1-1h-5.4c0-0.4,0-0.7-0.1-1H139.2L139.2,29.7z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.8,22.6l0.1-1h5.1h2.5c1.5,0,2.8,0.3,3.7,1H141.8L141.8,22.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "163.9,39.9 163.8,40.9 158.6,40.9 158.7,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.2,37.9 164,38.9 158.8,38.9 159,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.4,35.8 164.3,36.9 159.1,36.9 159.2,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "164.7,33.8 164.6,34.8 159.3,34.8 159.5,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165,31.8 164.8,32.8 159.6,32.8 159.7,31.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.2,29.7 165.1,30.7 159.8,30.7 160,29.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.5,27.7 165.4,28.7 160.1,28.7 160.2,27.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156.8,22.6 157,21.6 170.4,21.6 170.2,22.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156.6,24.6 156.7,23.6 170.1,23.6 170,24.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.5,24.6l0.1-1h12.7c0.2,0.3,0.5,0.6,0.6,1H141.5L141.5,24.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "146.6,25.7 146.4,26.7 141.2,26.7 141.4,25.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.2,28.7c0.1-0.3,0.2-0.6,0.1-1c0-0.5-0.1-0.8-0.2-1c-0.2-0.5-0.7-0.9-1.3-1h6.6c0.1,0.3,0.1,0.7,0.2,1 h-5.4c0.1,0.3,0.2,0.6,0.2,1h5.2c0,0.4,0,0.7-0.1,1H150.2L150.2,28.7z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.7,39.9 144.5,40.9 139.3,40.9 139.4,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "155.1,39.9 155.7,40.9 149.7,40.9 149.2,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.9,37.9 144.8,38.9 139.6,38.9 139.7,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "153.8,37.9 154.4,38.9 148.6,38.9 148.1,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "145.2,35.8 145.1,36.9 139.9,36.9 140,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "152.6,35.8 153.2,36.9 147.5,36.9 147,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "146.3,27.7 146.2,28.7 141,28.7 141.1,27.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.9,30.3h1.2c0.2,0,0.4,0,0.6,0c0.7,0,1.2-0.2,1.7-0.5h5.7c-0.1,0.4-0.3,0.7-0.4,1h-14.1l0.1-1h5.2V30.3 L145.9,30.3z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.4,32.8l0.1-1H154c-0.3,0.4-0.7,0.7-1.1,1H140.4L140.4,32.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "145.5,33.8 145.3,34.8 140.1,34.8 140.3,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.9,27.7c0.1,0.3,0.2,0.7,0.2,1h-5.6c-0.1-0.4-0.3-0.7-0.5-1H138.9L138.9,27.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138,25.7c0.2,0.3,0.4,0.7,0.5,1H132c-0.7-0.6-1.6-0.9-2.7-1H138L138,25.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.8,22.6c0.7-0.4,1.5-0.8,2.3-1h7.7c0.8,0.3,1.6,0.6,2.2,1H122.8L122.8,22.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.3,24.6c0.3-0.4,0.7-0.7,1-1h15c0.3,0.3,0.7,0.7,0.9,1H120.3L120.3,24.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119,26.7c0.2-0.4,0.4-0.7,0.6-1h8.5c-1,0.1-2,0.5-2.7,1H119L119,26.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.2,28.7c0.1-0.3,0.2-0.7,0.3-1h5.8c-0.2,0.3-0.4,0.6-0.6,1H118.2L118.2,28.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.2,30.5c0,0.1,0,0.2,0,0.3h-5.3v-0.1c0-0.3,0.1-0.6,0.1-0.9h5.3C123.2,30,123.2,30.2,123.2,30.5 L123.2,30.5z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.1,39.9c-0.8,0.4-1.6,0.8-2.5,1h-6.7c-0.9-0.2-1.7-0.6-2.5-1H134.1L134.1,39.9z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.6,37.9c-0.3,0.4-0.7,0.7-1.1,1H121c-0.4-0.3-0.7-0.7-1-1H136.6L136.6,37.9z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.6,35.8c0.8,0.5,1.8,0.8,2.9,0.8c1.1,0,2.1-0.3,2.9-0.8h6.7c-0.2,0.4-0.4,0.7-0.6,1h-18.2 c-0.2-0.3-0.4-0.7-0.5-1H125.6L125.6,35.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.8,33.8c-0.1,0.4-0.2,0.7-0.3,1h-5.9c0.3-0.3,0.5-0.6,0.7-1H138.8L138.8,33.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.7,33.8c0.2,0.4,0.4,0.7,0.7,1h-6.1c-0.1-0.3-0.2-0.7-0.3-1H123.7L123.7,33.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.9,24.6l0.1-1h13.2c0.2,0.3,0.4,0.6,0.6,1H101.9L101.9,24.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.1,28.7c0.1-0.3,0.1-0.6,0.1-1v-0.1c0-0.4-0.1-0.7-0.2-0.9c-0.3-0.7-1.1-1-2.5-1h-1.6l-0.1,1h-5.2l0.1-1 h14.4c0.1,0.3,0.1,0.7,0.2,1H111c0.1,0.3,0.2,0.6,0.2,0.9v0.1h5.1v0.2c0,0.3,0,0.6-0.1,0.8H111.1L111.1,28.7z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "106.7,27.7 106.5,28.7 101.3,28.7 101.4,27.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.3,30.5h2.1c1,0,1.7-0.3,2.2-0.8h5.5c-0.1,0.4-0.2,0.7-0.3,1H101l0.1-1h5.2L106.3,30.5L106.3,30.5z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,32.8l0.1-1h14.4c-0.2,0.4-0.5,0.7-0.8,1H100.8L100.8,32.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,34.8l0.1-1h12.5c-1.1,0.6-2.1,0.8-4.8,0.8h-2.5v0.2H100.5L100.5,34.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "100.2,36.9 100.3,35.8 105.7,35.8 105.5,36.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "99.9,38.9 100.1,37.9 105.4,37.9 105.2,38.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.9,22.6c0.5-0.4,1.1-0.8,1.8-1h6.8c0.7,0.2,1.2,0.5,1.7,0.8l0.4,0.3L88.9,22.6L88.9,22.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M87.4,24.6c0.2-0.4,0.3-0.7,0.6-1h11.3l-0.5,1H87.4L87.4,24.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.1,28.7c-0.1-0.3-0.2-0.7-0.2-1h5.8c-0.3-0.3-0.5-0.6-0.5-1h-5.3c0-0.4,0.1-0.7,0.2-1h5.7 c-0.3,0.3-0.5,0.7-0.5,1c0,0.4,0.1,0.7,0.5,1c0.2,0.2,0.5,0.4,0.9,0.6l0.9,0.4H87.1L87.1,28.7z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,39.9c-0.6,0.4-1.3,0.8-2,1h-6c-0.8-0.2-1.5-0.6-2.3-1H96.6L96.6,39.9z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.4,30.7c-0.3-0.3-0.6-0.7-0.8-1h8.9c0.5,0.3,0.9,0.6,1.3,1H88.4L88.4,30.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.6,32.8c-0.2-0.1-0.4-0.2-0.6-0.3c-0.5-0.2-0.9-0.5-1.3-0.7h8.9c0.2,0.3,0.3,0.7,0.5,1H91.6L91.6,32.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94,34.8c-0.1-0.4-0.2-0.7-0.6-1h5.8c0,0.2,0,0.4,0,0.7c0,0.1,0,0.2,0,0.4H94V34.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4,36.9l0.5-1h1.5c1.5,0.8,2.3,1,3.4,1c0.9,0,1.6-0.4,2-1h5.4c-0.1,0.4-0.2,0.7-0.3,1H86.4L86.4,36.9z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.4,37.9 83.3,38.9 76.1,38.9 75.5,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.7,35.8 83.5,36.9 74.9,36.9 74.5,36.2 74.3,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "80.2,22.6 80.4,21.6 85.6,21.6 85.4,22.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.9,24.6 80.1,23.6 85.3,23.6 85.2,24.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.6,26.7 79.7,25.7 85,25.7 84.9,26.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.4,28.7c0-0.4,0.1-0.7,0.1-1h5.3l-0.1,1H79.4L79.4,28.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.2,30.7c0-0.4,0-0.7,0.1-1h5.2l-0.1,1H79.2L79.2,30.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.1,32.8 79.2,31.8 84.2,31.8 84.1,32.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.7,33.8l0.3,0.6v-0.6h4.9l-0.1,1H73.7c-0.2-0.4-0.4-0.7-0.6-1H78.7L78.7,33.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.8,31.8c0.2,0.3,0.4,0.7,0.5,1h-5.8c-0.2-0.4-0.4-0.7-0.5-1H77.8L77.8,31.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.6,29.7c0.2,0.4,0.4,0.7,0.6,1h-5.8c-0.2-0.3-0.3-0.7-0.5-1H76.6L76.6,29.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.8,22.6 65.9,21.6 71.7,21.6 72.3,22.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.5,24.6 65.6,23.6 72.9,23.6 73.5,24.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.2,26.7 65.4,25.7 74.1,25.7 74.8,26.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.9,28.7l0.1-1h10.3l0.6,1h-5.5c-0.1-0.3-0.3-0.7-0.4-1l-0.1,1H64.9L64.9,28.7z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.7,30.7 64.8,29.7 69.9,29.7 69.8,30.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "64.4,32.8 64.5,31.8 69.7,31.8 69.6,32.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.1,34.8l0.1-1h5.3c0,0.4-0.1,0.7-0.1,1H64.1L64.1,34.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.8,36.9l0.1-1h5.3c0,0.3-0.1,0.6-0.1,0.9v0.1H63.8L63.8,36.9z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "63.5,38.9 63.7,37.9 69,37.9 68.8,38.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "62.9,39.9 63.2,40.9 57.8,40.9 57.5,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "62.4,37.9 62.7,38.9 57.2,38.9 56.9,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "61.9,35.8 62.2,36.9 45,36.9 45.6,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "61.4,33.8 61.7,34.8 46.1,34.8 46.6,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.9,31.8 52.5,32.8 47.1,32.8 47.6,31.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.6,29.7 53.3,30.7 48.1,30.7 48.6,29.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "54.4,27.7 54,28.7 49.1,28.7 49.6,27.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "52.1,22.6 52.6,21.6 58.3,21.6 58.5,22.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "51.1,24.6 51.6,23.6 58.8,23.6 59,24.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.1,26.7 50.6,25.7 59.3,25.7 59.6,26.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.2,28.7 55,27.7 59.8,27.7 60.1,28.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.5,30.7 55.3,29.7 60.3,29.7 60.6,30.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.5,24.6l0.1-1h12.8c0.2,0.3,0.5,0.6,0.6,1H31.5L31.5,24.6z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.6,25.7 36.4,26.7 31.2,26.7 31.3,25.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,28.7c0.1-0.3,0.2-0.6,0.1-1c0-0.5-0.1-0.8-0.2-1c-0.2-0.5-0.7-0.9-1.3-1h6.6c0.1,0.3,0.1,0.7,0.2,1 h-5.4c0.1,0.3,0.2,0.6,0.2,1h5.2c0,0.4,0,0.7-0.1,1H40.2L40.2,28.7z",
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.6,39.9 34.5,40.9 29.3,40.9 29.4,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "34.9,37.9 34.8,38.9 29.6,38.9 29.7,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.2,35.8 35,36.9 29.8,36.9 30,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "42.6,35.8 43.2,36.9 37.5,36.9 37,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "36.3,27.7 36.1,28.7 30.9,28.7 31.1,27.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.9,30.3h1.2c0.2,0,0.4,0,0.6,0c0.7,0,1.2-0.2,1.7-0.5h5.7c-0.1,0.4-0.3,0.7-0.4,1h-14l0.1-1H36L35.9,30.3 L35.9,30.3z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.4,32.8l0.1-1H44c-0.3,0.4-0.7,0.7-1.1,1H30.4L30.4,32.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "35.4,33.8 35.3,34.8 30.1,34.8 30.3,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.8,37.9 24.6,38.9 19.5,38.9 19.6,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25,35.8 24.9,36.9 19.7,36.9 19.8,35.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.3,33.8 25.2,34.8 20,34.8 20.1,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.6,31.8 25.4,32.8 20.2,32.8 20.3,31.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "25.8,29.7 25.7,30.7 20.5,30.7 20.6,29.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "26.1,27.7 26,28.7 20.7,28.7 20.8,27.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.5,22.6 17.6,21.6 31,21.6 30.9,22.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.2,24.6 17.3,23.6 30.7,23.6 30.6,24.6 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41.3,33.8 41.9,34.8 36.4,34.8 35.9,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "55.8,32.8 55.6,31.8 60.9,31.8 61.1,32.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "63.2,40.9 63.4,39.9 68.6,39.9 68.5,40.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M85.3,38.9l0.5-1h12.6c-0.2,0.4-0.5,0.7-0.7,1H85.3L85.3,38.9z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "99.7,40.9 99.8,39.9 105.1,39.9 104.9,40.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.1,31.8c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.5,0.1,0.7h-5.4c0-0.3-0.1-0.7-0.1-1H123.1L123.1,31.8z",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "151.3,33.8 152,34.8 146.4,34.8 145.9,33.8 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "156.3,26.7 156.4,25.7 169.9,25.7 169.7,26.7 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "49.2,39.9 48.7,40.9 39.7,40.9 39.1,39.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50.2,37.9 49.7,38.9 38.6,38.9 38.1,37.9 43.8,37.9 44.2,38.5 44.5,37.9 \t\t",
    style: {
      fill: "rgb(51, 51, 51)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsLogo);
export default __webpack_public_path__ + "static/media/rs_logo.5f3fafb757a65f05a5bfd1e44fea252a.svg";
export { ForwardRef as ReactComponent };